import { render } from "./ViewAllReviews.vue?vue&type=template&id=f9072f84"
import script from "./ViewAllReviews.vue?vue&type=script&lang=js"
export * from "./ViewAllReviews.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__